import {Component, DoCheck, Inject, IterableDiffers, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {BaseStepComponent} from '../base-step/base-step.component';
import {GuestCredit} from '../../shared/models/guest-credit';
import {ValidationExpressions} from '../../shared/validation/validation.expressions';
import {WORKFLOW_DATA_SERVICE_TOKEN} from '../../shared/services/workflow-data.service';
import {NavigationService} from '../../shared/services/navigation.service';
import {Reservation} from '../../shared/models/reservation';

@Component({
  selector: 'app-reservation-step',
  templateUrl: './reservation-step.component.html',
  styleUrls: ['./reservation-step.component.css']
})
export class ReservationStepComponent extends BaseStepComponent implements OnInit, DoCheck, OnDestroy {
  public pnr: string;
  public wviBookingId: string;
  public guests: Array<GuestCredit> = [];
  public guestNameRegex: string = ValidationExpressions.guestName;
  public ticketNumberRegex: string = ValidationExpressions.ticketNumber;
  public wviBookingIdRegex: string = ValidationExpressions.wviBookingId;
  public canDelete = true;
  differ: any;
  private subscription: any;

  constructor(route: ActivatedRoute, @Inject(WORKFLOW_DATA_SERVICE_TOKEN) private workflowDataService, differs: IterableDiffers,
              navigationService: NavigationService, router: Router) {
    super(route, navigationService, router);

    this.differ = differs.find([]).create(null);
  }

  ngOnInit() {
    this.subscription =  this.workflowDataService.getReservation.subscribe(reservation => {
      this.pnr = reservation == null ? null : reservation.pnr;
      this.wviBookingId = reservation == null ? null : reservation.wviBookingId;
      this.guests = reservation == null ? new Array<GuestCredit>() : reservation.guestCredits;
      if (!reservation) {
        this.addGuestRow();
      }
    });
  }

  ngDoCheck() {
    let changes = this.differ.diff(this.guests);

    if (changes) {
      this.canDelete = this.guests.length > 1
    }
  }

  addGuestRow() {
    this.guests.push(new GuestCredit());
  }

  deleteGuestRow(i: number) {
    this.guests.splice(i, 1);
    this.guests = this.guests.map(g => Object.assign(new GuestCredit(), g));
  }

  setReservation() {
    let reservation = new Reservation(this.pnr, this.wviBookingId, this.guests);
    this.workflowDataService.setReservation(reservation);
  }

  ngOnDestroy() {
    if(this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/steps/reservation-step/reservation-step.component.ts